import Price from '~/utils/Price/Price';

import CountryOfOrigin from './CountryOfOrigin';
import GeneralInformation from './GeneralInformation';

export default class Reference {
	referenceBasketVersion: string;

	generalInformation: GeneralInformation;

	proposedCifPrice: Price | null;

	countryOfOrigin: CountryOfOrigin;

	constructor(
		referenceBasketVersion: string,
		generalInformation: GeneralInformation,
		proposedCifPrice: Price | null,
		countryOfOrigin: CountryOfOrigin
	) {
		this.referenceBasketVersion = referenceBasketVersion;
		this.generalInformation = generalInformation;
		this.proposedCifPrice = proposedCifPrice;
		this.countryOfOrigin = countryOfOrigin;
	}
}
